import { ButtonProps } from 'antd/lib/button';

import { StyledButton } from './styles';

export function UiButton(props: ButtonProps) {
  return <StyledButton {...props} />;
}
